import { useLocation, useNavigate } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import { Badge } from "../../../Component/OperationComponents/Badge";
import { SectionCard } from "../../../Component/OperationComponents/SectionCard";
import Pagination from "../../../Component/Common/Pagination";
import RefreshButton from "../../../Component/Common/RefreshButton";
import RegularLoader from "../../../Component/Loader/RegularLoader";
import { BASE_URL } from "../../../config/api";

export default function OprRetailersView() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("retailer");
  const location = useLocation();
  const filterType = location.state?.filter || null;

  /* ---------------- SESSION USER ---------------- */
  const authUser = localStorage.getItem("authUserData")
    ? JSON.parse(localStorage.getItem("authUserData"))
    : null;

  const companyId = authUser?.company_id;
  const locationMode = authUser?.location_mode;
  const state = authUser?.state;
  const district = authUser?.district;

  const showTabs =
  authUser?.role === 3 &&
  Array.isArray(authUser?.handle) &&
  authUser.handle.includes("AGENT") &&
  authUser.handle.includes("RETAILER");

  /* ---------------- STATES ---------------- */
  const [retailers, setRetailers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchRetailer, setSearchRetailer] = useState("");
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);

  /* ---------------- PAGINATION ---------------- */
  const [currentPage, setCurrentPage] = useState(1);
  const [searchField, setSearchField] = useState("business_name");
  const [searchValue, setSearchValue] = useState("");

  const pageSize = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchRetailer]);

  const buildLocationParams = () => {
  const params = {};

  if (locationMode === "state" && state) {
    params.states = state;
  }

  if (locationMode === "district" && district) {
    params.district = district;
  }

  return params;
};


const WARRANTY_API_MAP = {
  assigned: "warranty/assigned-retailers",
  connected: "warranty/connected-retailers",
  using: "warranty/using-retailers",
};


  /* ---------------- FETCH RETAILERS ---------------- */
  // const fetchRetailers = async () => {
  //   try {
  //     setLoading(true);

  //     const roleParam =
  //     showTabs && activeTab === "agent" ? 4 : 5;


  //     let url = `${BASE_URL}company/list?company_id=${companyId}&role=${roleParam}`;

  //     if (locationMode === "state" && state) {
  //       url += `&state=${encodeURIComponent(state)}`;
  //     }

  //     if (locationMode === "district" && district) {
  //       url += `&district=${encodeURIComponent(district)}`;
  //     }

  //     const res = await fetch(url);
  //     const json = await res.json();

  //     if (json?.status) {
  //       setRetailers(json.data || []);
  //     } else {
  //       setRetailers([]);
  //     }
  //   } catch (err) {
  //     console.error("Failed to fetch retailers", err);
  //     setRetailers([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // const fetchRetailers = async () => {
  //   try {
  //     setLoading(true);

  //     const roleParam =
  //       showTabs && activeTab === "agent" ? 4 : 5;

  //     let url = `${BASE_URL}company/list?company_id=${companyId}&role=${roleParam}`;

  //     // 🔹 LOCATION FILTER
  //     if (locationMode === "state" && state) {
  //       url += `&state=${encodeURIComponent(state)}`;
  //     }

  //     if (locationMode === "district" && district) {
  //       url += `&district=${encodeURIComponent(district)}`;
  //     }

  //     // 🔹 SEARCH FILTER (only if input exists)
  //     if (searchValue.trim()) {
  //       url += `&${searchField}=${encodeURIComponent(searchValue.trim())}`;
  //     }

  //     const res = await fetch(url);
  //     const json = await res.json();

  //     if (json?.status) {
  //       setRetailers(json.data || []);
  //     } else {
  //       setRetailers([]);
  //     }
  //   } catch (err) {
  //     console.error("Failed to fetch retailers", err);
  //     setRetailers([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchMainRetailers = async () => {
  const roleParam = showTabs && activeTab === "agent" ? 4 : 5;

  let url = `${BASE_URL}company/list?company_id=${companyId}&role=${roleParam}`;

  if (locationMode === "state" && state) {
    url += `&state=${encodeURIComponent(state)}`;
  }

  if (locationMode === "district" && district) {
    url += `&district=${encodeURIComponent(district)}`;
  }

  if (searchValue.trim()) {
    url += `&${searchField}=${encodeURIComponent(searchValue.trim())}`;
  }

  const res = await fetch(url);
  const json = await res.json();

  return json?.status ? json.data || [] : [];
};

const fetchWarrantyRetailers = async () => {
  const params = buildLocationParams();

  const res = await fetch(
    `${BASE_URL}${WARRANTY_API_MAP[filterType]}?${new URLSearchParams(params)}`
  );

  const json = await res.json();
  return json?.success ? json.data || [] : [];
};


const mergeRetailersById = (mainList, filterList) => {
  const filterMap = new Map(filterList.map(r => [r.id, r]));

  return mainList
    .filter(r => filterMap.has(r.id))   // keep only matched retailers
    .map(r => ({
      ...r,                            // full main API data
      ...filterMap.get(r.id),          // overlay warranty fields
    }));
};



  const fetchRetailers = async () => {
  try {
    setLoading(true);

    // 🔹 KPI FILTER FLOW
    if (
      filterType &&
      WARRANTY_API_MAP[filterType] &&
      activeTab === "retailer"
    ) {
      const [mainRetailers, warrantyRetailers] = await Promise.all([
        fetchMainRetailers(),
        fetchWarrantyRetailers(),
      ]);

      const merged = mergeRetailersById(
        mainRetailers,
        warrantyRetailers
      );

      setRetailers(merged);
      return;
    }

    // 🔹 NORMAL FLOW
    const mainRetailers = await fetchMainRetailers();
    setRetailers(mainRetailers);
  } catch (err) {
    console.error("Failed to fetch retailers", err);
    setRetailers([]);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  fetchRetailers();
}, [filterType, activeTab]);

useEffect(() => {
  const t = setTimeout(fetchRetailers, 400);
  return () => clearTimeout(t);
}, [searchValue, searchField, activeTab]);


  /* ---------------- SEARCH ---------------- */
  // const filteredSearch = useMemo(() => {
  //   const s = searchRetailer.toLowerCase();

  //   return retailers.filter((r) => {
  //     return (
  //       r.business_name?.toLowerCase().includes(s) ||
  //       r.city?.toLowerCase().includes(s) ||
  //       r.state?.toLowerCase().includes(s) ||
  //       r.gst?.toLowerCase().includes(s) ||
  //       r.contact_phone?.toLowerCase().includes(s)
  //     );
  //   });
  // }, [searchRetailer, retailers]);

  /* ---------------- PAGINATED DATA ---------------- */
  const totalPages = Math.ceil(retailers.length / pageSize);

  const paginatedRetailers = retailers.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  /* ---------------- UI ---------------- */
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-4 space-y-3">

        <div className="bg-white">
          {showTabs && (
          <div className="flex gap-2 mb-3">
            <button
              onClick={() => setActiveTab("retailer")}
              className={`px-3 py-1 text-sm rounded-lg font-semibold transition ${
                activeTab === "retailer"
                  ? "bg-blue-600 text-white"
                  : "bg-blue-50 text-blue-700 hover:bg-blue-100"
              }`}
            >
              Retailers
            </button>

            <button
              onClick={() => setActiveTab("agent")}
              className={`px-3 py-1 text-sm rounded-lg font-semibold transition ${
                activeTab === "agent"
                  ? "bg-blue-600 text-white"
                  : "bg-blue-50 text-blue-700 hover:bg-blue-100"
              }`}
            >
              Agents
            </button>
          </div>
        )}
        </div>

        <SectionCard
          title={showTabs && activeTab === "agent" ? "Agents" : "Retailers"}
        >
          
            <div className="flex justify-end gap-2 mb-3">
              {/* <input
                type="text"
                placeholder="Search by name, city, GST, phone..."
                value={searchRetailer}
                onChange={(e) => setSearchRetailer(e.target.value)}
                className="text-sm border border-slate-200 rounded-lg px-2 py-1 w-48 md:w-64"
              /> */}

                <select
                  value={searchField}
                  onChange={(e) => setSearchField(e.target.value)}
                  className="text-sm border border-slate-200 rounded-lg px-1 py-1"
                >
                  <option value="business_name">Business Name</option>
                  <option value="company_code">Code</option>
                  <option value="city">City</option>
                  <option value="state">State</option>
                  <option value="district">District</option>
                  <option value="pincode">Pincode</option>
                </select>

                {/* SEARCH INPUT */}
                <input
                  type="text"
                  placeholder={`Search by ${searchField.replace("_", " ")}`}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="text-sm border border-slate-200 rounded-lg px-2 py-1 w-40 md:w-56"
                />

                <div className="hidden lg:block">
                  <RefreshButton onClick={fetchRetailers} />
                </div>
                
              </div>
    
          {loading ? (
            <RegularLoader />
          ) : (
            <>

            {/* Mobile Card Layout */}
              <div className="lg:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                {paginatedRetailers.map((r) => (
                  <div
                    key={r.id}
                    onClick={() => setSelectedRetailerId(r.id)}
                    className="bg-white rounded-2xl border border-slate-200 shadow-[0_4px_14px_rgba(0,0,0,0.05)] p-4 active:scale-[0.99] transition-all duration-200"
                  >
                    {/* Top Section */}
                    <div className="flex justify-between items-start">
                      <div className="flex flex-col">
                        <h3 className="text-sm font-semibold text-slate-800 leading-tight">
                          {r.business_name}
                        </h3>
                        <span className="text-xs text-slate-400 mt-0.5">
                          {r.company_code}
                        </span>

                        <a
                            href={`tel:${r.contact_phone}`}
                            onClick={(e) => e.stopPropagation()}
                            className="text-xs font-medium text-blue-600"
                          >
                            {r.contact_phone}
                          </a>
                      </div>

                      <Badge color={r.status === 1 ? "green" : "red"}>
                        {r.status === 1 ? "Active" : "Inactive"}
                      </Badge>
                    </div>

                    {/* Divider */}
                    <div className="my-3 h-px bg-slate-100" />

                    {/* Info Grid */}
                    <div className="grid grid-cols-2 gap-y-3 text-xs">
                      <div>
                        <p className="text-slate-400">Location</p>
                        <p className="text-slate-700 font-medium">
                          {r.district}, {r.state}
                        </p>
                      </div>

                      <div>
                        <p className="text-slate-400">Pincode</p>
                        <p className="text-slate-700 font-medium">
                          {r.pincode || "-"}
                        </p>
                      </div>

                      <div>
                        <p className="text-slate-400">Verification</p>
                        <Badge color={r.is_verified === 7 ? "blue" : "gray"}>
                          {r.is_verified === 7 ? "On" : "Pending"}
                        </Badge>
                      </div>

                      <div>
                        <p className="text-slate-400">Created By</p>
                        {r.created_by_name || "-"}
                      </div>
                    </div>

                    {/* Contact Section */}
                    <div className="mt-4 flex items-center justify-end">
                    
                      {/* <p className="mt-0.5 text-sm text-slate-500">
                        
                      </p> */}

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/user/${r.id}`, {
                            state: {
                              entityType:
                                activeTab === "agent" ? "agent" : "retailer",
                              data: r,
                            },
                          });
                        }}
                        className="px-4 py-1.5 text-xs font-semibold rounded-full bg-blue-600 text-white hover:bg-blue-700 transition"
                      >
                        View
                      </button>
                    </div>
                  </div>
                ))}

                {paginatedRetailers.length === 0 && (
                  <div className="text-center text-sm text-slate-500 py-6">
                    No user found.
                  </div>
                )}
              </div>

              <div className="hidden lg:block overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead>
                    <tr className="border-b border-slate-100 text-slate-500">
                      <th className="py-2 text-left">Retailer</th>
                      {/* <th className="py-2 text-left">City</th> */}
                      <th className="py-2 text-left">Status</th>
                      <th className="py-2 text-left">Verified</th>
                      <th className="py-2 text-left">Phone</th>
                      <th className="py-2 text-left">Created By</th>
                      <th className="py-2 text-right">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedRetailers.map((r) => (
                      <tr
                        key={r.id}
                        onClick={() => setSelectedRetailerId(r.id)}
                        className="border-b border-slate-50 cursor-pointer hover:bg-blue-50/60"
                      >
                        <td className="py-2">
                          
                          <div className="font-medium text-slate-800">
                            {r.business_name} ({r.company_code})
                          </div>
                          <div className="text-xs text-slate-500">
                            {r.district}, {r.state}, {r.pincode}
                          </div>
                        </td>

                        <td className="py-2 text-sm text-slate-600">
                          {r.district}
                        </td>

                        <td className="py-2">
                          <Badge color={r.status === 1 ? "green" : "red"}>
                            {r.status === 1 ? "Active" : "Inactive"}
                          </Badge>
                        </td>

                        <td className="py-2">
                          <Badge color={r.is_verified === 7 ? "blue" : "gray"}>
                            {r.is_verified === 7 ? "Onboarded" : "In Progress"}
                          </Badge>
                        </td>

                        <td className="py-2 text-sm text-blue-700">
                          <a href={`tel:${r.contact_phone}`}>
                            📞 {r.contact_phone}
                          </a>
                        </td>

                         <td className="py-2 text-sm text-slate-600">
                            {r.created_by_id === authUser?.id ? (
                              <Badge color="green">Self</Badge>
                            ) : r.agent_id !== null ? (
                              <Badge color="blue">By Agent</Badge>
                            ) : (
                              <Badge color="gray">Other</Badge> // optional fallback
                            )}

                            <p className="mt-0.5 text-sm text-slate-500">
                              {r.created_by_name || "-"}
                            </p>
                          </td>


                        <td
                          className="py-2 text-right"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={() =>
                              navigate(`/user/${r.id}`, {
                                state: {
                                  entityType: activeTab === "agent" ? "agent" : "retailer",
                                  data: r,
                                },
                              })
                            }
                            className="px-2 py-1 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
                          >
                            View
                          </button>

                        </td>
                      </tr>
                    ))}

                    {paginatedRetailers.length === 0 && (
                      <tr>
                        <td
                          colSpan={6}
                          className="py-4 text-center text-sm text-slate-500"
                        >
                          No user found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </div>
              )}
            </>
          )}
        </SectionCard>
      </div>
    </div>
  );
}




// import { useNavigate } from "react-router-dom";
// import { useState, useMemo, useEffect } from "react";
// import { Badge } from "../../../Component/OperationComponents/Badge";
// import { SectionCard } from "../../../Component/OperationComponents/SectionCard";
// import Pagination from "../../../Component/Common/Pagination";
// import RetailerDetailsPanel from "./RetailerDetails";
// import RefreshButton from "../../../Component/Common/RefreshButton";

// export default function OprRetailersView({}) {
//   const navigate = useNavigate();

//   // ********* MOCK RETAILERS (your provided data) *********
//   const mockRetailers = [
//     {
//       id: 1,
//       name: "Shree Mobile Store",
//       code: "RT001",
//       city: "Pune",
//       isActive: true,
//       isConnected: true,
//       usingProduct: true,
//       phone: "+91 9876543210",
//       email: "owner@shreemobile.in",
//       contactPerson: "Rahul Patil",
//       gstin: "27ABCDE1234F1Z5",
//       address: "Shop 12, Main Market, Pune",
//       totalSales: 450000,
//       monthSales: 75000,
//       outstanding: 15000,
//       lastPaymentDate: "2025-11-01",
//       productMix: [
//         { product: "POS License", value: 25000 },
//         { product: "Recharge API", value: 30000 },
//         { product: "DMT", value: 20000 },
//       ],
//     },
//     {
//       id: 2,
//       name: "Sai Telecom",
//       code: "RT002",
//       city: "Mumbai",
//       isActive: true,
//       isConnected: false,
//       usingProduct: false,
//       phone: "+91 9822001122",
//       email: "sai@telecom.com",
//       contactPerson: "Sanjay More",
//       gstin: "27PQRSX6789L1Z8",
//       address: "G-5, Station Road, Mumbai",
//       totalSales: 120000,
//       monthSales: 12000,
//       outstanding: 5000,
//       lastPaymentDate: "2025-10-25",
//       productMix: [
//         { product: "POS License", value: 60000 },
//         { product: "Recharge API", value: 30000 },
//         { product: "AEPS", value: 30000 },
//       ],
//     },
//     {
//       id: 3,
//       name: "Om Electronics",
//       code: "RT003",
//       city: "Nashik",
//       isActive: false,
//       isConnected: false,
//       usingProduct: false,
//       phone: "+91 9988776655",
//       email: "info@omelectronics.in",
//       contactPerson: "Prakash Jadhav",
//       gstin: "27XYZAB1357K1Z9",
//       address: "Shop 3, City Center, Nashik",
//       totalSales: 80000,
//       monthSales: 0,
//       outstanding: 0,
//       lastPaymentDate: "2025-08-10",
//       productMix: [
//         { product: "POS License", value: 30000 },
//         { product: "Recharge API", value: 20000 },
//         { product: "DMT", value: 30000 },
//       ],
//     },
//   ];

//   // ******** STATES ********
//   const [searchRetailer, setSearchRetailer] = useState("");
//   const [selectedRetailerId, setSelectedRetailerId] = useState(null);
//   const selectedRetailer = mockRetailers.find((r) => r.id === selectedRetailerId);

//   // ******** PAGINATION ********
//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 2;

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchRetailer]);

//   // ******** SEARCH LOGIC ********
//   const filteredSearch = useMemo(() => {
//     const s = searchRetailer.toLowerCase();

//     return mockRetailers.filter((r) => {
//       return (
//         r.name.toLowerCase().includes(s) ||
//         r.city.toLowerCase().includes(s) ||
//         r.code.toLowerCase().includes(s) ||
//         r.gstin.toLowerCase().includes(s) ||
//         r.phone.toLowerCase().includes(s)
//       );
//     });
//   }, [searchRetailer]);

//   // ******** PAGINATED DATA ********
//   const totalPages = Math.ceil(filteredSearch.length / pageSize);

//   const paginatedRetailers = filteredSearch.slice(
//     (currentPage - 1) * pageSize,
//     currentPage * pageSize
//   );

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">

//       {/* List */}
//       <div className="lg:col-span-4 space-y-3">
//         <SectionCard
//           title="Retailers"
//           right={
//             <div className="flex gap-2">
//             <input
//               type="text"
//               placeholder="Search by name, code, city, GSTIN..."
//               value={searchRetailer}
//               onChange={(e) => setSearchRetailer(e.target.value)}
//               className="text-sm border border-slate-200 rounded-lg px-2 py-1 w-48 md:w-64"
//             />
//             <RefreshButton/>
//             </div>
//           }
          
//         >
//           <div className="overflow-x-auto">
//             <table className="min-w-full text-sm">
//               <thead>
//                 <tr className="border-b border-slate-100 text-slate-500">
//                   <th className="py-2 text-left">Retailer</th>
//                   <th className="py-2 text-left">City</th>
//                   <th className="py-2 text-left">Status</th>
//                   <th className="py-2 text-left">Using</th>
//                   <th className="py-2 text-left">Connected</th>
//                   <th className="py-2 text-left">Phone</th>
//                   <th className="py-2 text-right">Monthly Sales</th>
//                   <th className="py-2 text-right">Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginatedRetailers.map((r) => (
//                   <tr
//                     key={r.id}
//                     onClick={() => setSelectedRetailerId(r.id)}
//                     className={`border-b border-slate-50 cursor-pointer hover:bg-blue-50/60 ${
//                       selectedRetailerId === r.id ? "bg-blue-50" : "bg-white"
//                     }`}
//                   >
//                     <td className="py-2">
//                       <div className="font-medium text-slate-800">{r.name}</div>
//                       <div className="text-sm text-slate-500">
//                         {r.code} · GSTIN: {r.gstin}
//                       </div>
//                     </td>

//                     <td className="py-2 text-sm text-slate-600">{r.city}</td>

//                     <td className="py-2">
//                       <Badge color={r.isActive ? "green" : "red"}>
//                         {r.isActive ? "Active" : "Inactive"}
//                       </Badge>
//                     </td>

//                     <td className="py-2">
//                       <Badge color={r.usingProduct ? "blue" : "gray"}>
//                         {r.usingProduct ? "Using" : "Not using"}
//                       </Badge>
//                     </td>

//                     <td className="py-2">
//                       <Badge color={r.isConnected ? "green" : "red"}>
//                         {r.isConnected ? "Connected" : "Not Connected"}
//                       </Badge>
//                     </td>

//                     <td className="py-2 text-sm text-blue-700">
//                       <a href={`tel:${r.phone.replace(/\s/g, "")}`}>
//                         📞 {r.phone}
//                       </a>
//                     </td>

//                     <td className="py-2 text-sm text-right text-slate-700">
//                       ₹{(r.monthSales / 1000).toFixed(1)}k
//                     </td>

//                     {/* VIEW BUTTON */}
//                     <td
//                       className="py-2 text-right"
//                       onClick={(e) => e.stopPropagation()}
//                     >
//                       <button
//                         onClick={() =>
//                           navigate(`/retailer/${r.id}`, {
//                             state: { retailer: r },
//                           })
//                         }
//                         className="px-2 py-1 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
//                       >
//                         View
//                       </button>
//                     </td>
//                   </tr>
//                 ))}

//                 {filteredSearch.length === 0 && (
//                   <tr>
//                     <td
//                       colSpan={8}
//                       className="py-4 text-center text-sm text-slate-500"
//                     >
//                       No retailers found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           {totalPages > 1 && (
//             <div className="mt-3">
//               <Pagination
//                 currentPage={currentPage}
//                 totalPages={totalPages}
//                 onPageChange={setCurrentPage}
//               />
//             </div>
//           )}
//         </SectionCard>
//       </div>
//     </div>
//   );
// }



// import { useNavigate } from "react-router-dom";
// import { Badge } from "../../../Component/OperationComponents/Badge";
// import { SectionCard } from "../../../Component/OperationComponents/SectionCard";
// import RetailerDetailsPanel from "./RetailerDetails";

// export default function RetailersView({
//   retailers,
//   allRetailers,
//   searchRetailer,
//   setSearchRetailer,
//   selectedRetailer,
//   setSelectedRetailerId,
// }) {

//   const navigate = useNavigate();
//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       {/* List */}
//       <div className="lg:col-span-4 space-y-3">
//         <SectionCard
//           title="Retailers"
//           right={
//             <input
//               type="text"
//               placeholder="Search by name, code, city, GSTIN..."
//               value={searchRetailer}
//               onChange={(e) => setSearchRetailer(e.target.value)}
//               className="text-sm border border-slate-200 rounded-lg px-2 py-1 w-48 md:w-64"
//             />
//           }
//         >
//           <div className="overflow-x-auto">
//             <table className="min-w-full text-sm">
//               <thead>
//                 <tr className="border-b border-slate-100 text-slate-500">
//                   <th className="py-2 text-left">Retailer</th>
//                   <th className="py-2 text-left">City</th>
//                   <th className="py-2 text-left">Status</th>
//                   <th className="py-2 text-left">Using</th>
//                   <th className="py-2 text-left">Connected</th>
//                   <th className="py-2 text-left">Phone</th>
//                   <th className="py-2 text-right">Monthly Sales</th>
//                   <th className="py-2 text-right">Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {retailers.map((r) => (
//                   <tr
//                     key={r.id}
//                     onClick={() => setSelectedRetailerId(r.id)}
//                     className={`border-b border-slate-50 cursor-pointer hover:bg-blue-50/60 ${
//                       selectedRetailer && selectedRetailer.id === r.id
//                         ? "bg-blue-50"
//                         : "bg-white"
//                     }`}
//                   >
//                     <td className="py-2">
//                       <div className="font-medium text-slate-800">
//                         {r.name}
//                       </div>
//                       <div className="text-sm text-slate-500">
//                         {r.code} · GSTIN: {r.gstin}
//                       </div>
//                     </td>

//                     <td className="py-2 text-sm text-slate-600">{r.city}</td>

//                     <td className="py-2">
//                       <Badge color={r.isActive ? "green" : "red"}>
//                         {r.isActive ? "Active" : "Inactive"}
//                       </Badge>
//                     </td>

//                     <td className="py-2">
//                       <Badge color={r.usingProduct ? "blue" : "gray"}>
//                         {r.usingProduct ? "Using" : "Not using"}
//                       </Badge>
//                     </td>

//                     <td className="py-2">
//                       <Badge color={r.isConnected ? "green" : "red"}>
//                         {r.isConnected ? "Connected" : "Not Connected"}
//                       </Badge>
//                     </td>

//                     <td className="py-2 text-sm text-blue-700">
//                       <a href={`tel:${r.phone.replace(/\s/g, "")}`}>
//                         📞 {r.phone}
//                       </a>
//                     </td>

//                     <td className="py-2 text-sm text-right text-slate-700">
//                       ₹{(r.monthSales / 1000).toFixed(1)}k
//                     </td>

//                     {/* VIEW BUTTON */}
//                     <td
//                       className="py-2 text-right"
//                       onClick={(e) => e.stopPropagation()} // prevents row click
//                     >
//                       <button
//                         onClick={() =>
//                           navigate(`/retailer/${r.id}`, {
//                             state: {
//                               retailer: r,
//                               allRetailers,
//                             },
//                           })
//                         }
//                         className="px-2 py-1 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-700"
//                       >
//                         View
//                       </button>

//                     </td>
//                   </tr>
//                 ))}

//                 {retailers.length === 0 && (
//                   <tr>
//                     <td
//                       colSpan={8}
//                       className="py-4 text-center text-sm text-slate-500"
//                     >
//                       No retailers found with this search.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </SectionCard>
//       </div>

//       {/* Detail Panel */}
//     </div>
//   );
// }
  